module.exports = __webpack_public_path__ + "static/logo-712705cc6d8e54729fd68cdc2c938c90.png";